import styled from 'styled-components';
import ColorUtils from '../../../../common/color-utils';

const CountingBadge = ({ badgeCount, subnavActiveLinkColor }) => (
  <CountingBadgeWrapper subnavActiveLinkColor={subnavActiveLinkColor}>{badgeCount}</CountingBadgeWrapper>
);

const CountingBadgeWrapper = styled.div`
  background: ${(props) => (props.subnavActiveLinkColor ? props.subnavActiveLinkColor : '#1162BF')};
  color: ${(props) =>
    ColorUtils.getTextColorForHex(props.subnavActiveLinkColor ? props.subnavActiveLinkColor : '#1162BF')};
  height: 20px;
  min-width: 20px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 12px;
`;

export default CountingBadge;
